import React, { ReactElement } from 'react';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { ScreenWrapper } from '../styles/Containers';
import { NavigationProps } from './FlowNavigation';
import { AiLoadingLayout, AiLoadingLayoutConfig } from './layouts/AiLoadingLayout';

export type AiLoadingScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.AiLoading,
  AiLoadingLayoutConfig,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  AiLoadingScreenConfig<ScreenNames>,
  ScreenNames
>;

export const AiLoadingScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  return (
    <ScreenWrapper>
      {/* Reset history so the user cannot navigate back onto this screen, which would only replay
          the animation and push them forward again. */}
      <AiLoadingLayout
        onComplete={() => props.navigation.next(props, { resetHistory: true })}
        {...props.layout}
      />
    </ScreenWrapper>
  );
};
